import React from 'react';
import { Sparkles, TrendingUp, Target, Zap } from 'lucide-react';

const AICapabilities = () => {
  const aiFeatures = [
    {
      icon: Sparkles,
      title: 'AI-Powered Analytics',
      stat: '+37% ROI',
      description: 'Using AI analytics, we improved campaign ROI by 37% through intelligent optimization and predictive modeling.',
    },
    {
      icon: Target,
      title: 'Smart Audience Targeting',
      stat: '92% Accuracy',
      description: 'Machine learning algorithms identify and target high-value audiences with unprecedented precision.',
    },
    {
      icon: TrendingUp,
      title: 'Predictive Optimization',
      stat: '45% Faster',
      description: 'AI-driven insights enable real-time campaign adjustments, delivering results 45% faster than traditional methods.',
    },
    {
      icon: Zap,
      title: 'Automated Performance Tuning',
      stat: '60% Efficiency',
      description: 'Smart automation continuously optimizes bids, creatives, and placements for maximum performance.',
    },
  ];

  return (
    <section className="py-24 relative bg-slate-950/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="inline-flex items-center space-x-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 backdrop-blur-sm mb-6">
            <Sparkles className="w-4 h-4 text-cyan-400" />
            <span className="text-sm text-cyan-400 font-medium">AI-Powered Marketing</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Intelligence That
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              Drives Results
            </span>
          </h2>
          <p className="text-xl text-slate-400 leading-relaxed">
            Leveraging cutting-edge AI and machine learning to maximize your marketing performance and ROI.
          </p>
        </div>

        {/* AI Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {aiFeatures.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group relative bg-slate-900/40 backdrop-blur-xl border border-slate-800/50 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300"
              >
                {/* Icon */}
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 group-hover:from-cyan-500/30 group-hover:to-blue-500/30 transition-all duration-300">
                    <Icon className="w-7 h-7 text-cyan-400" />
                  </div>
                </div>

                {/* Content */}
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold text-white">{feature.title}</h3>
                    <span className="text-cyan-400 text-sm font-semibold bg-cyan-500/10 px-3 py-1 rounded-full">
                      {feature.stat}
                    </span>
                  </div>
                  <p className="text-slate-400 text-sm leading-relaxed">{feature.description}</p>
                </div>

                {/* Hover Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-cyan-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AICapabilities;
